<template>
  <div>
    <v-row>
      <v-col md="12" v-if="!isViewModal && !isEdit">
        <v-btn size="small" color="blue-grey" prepend-icon="$plus" class="pl-4 text-white" @click="newComposition">
          <span>Agregar Composición</span>
        </v-btn>
      </v-col>

      <v-col md="12">
        <v-data-table :headers="header_custome" :items="product.composite_kit" style="border: solid 1px #1c1c1c" :hide-default-footer="true" :items-per-page="100">
          <template v-slot:item="{ item }">
            <tr>
              <td>
                {{ item.component_product_presentation.label }}
              </td>
              <td>
                {{ item.amount }}
              </td>

              <td class="text-center" style="width: 110px" v-if="!isViewModal && !item.id">
                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="blue" class="mr-2" v-on:click="editComposition(item)" size="small"> mdi-pencil</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="red" class="mr-2" v-on:click="removeComposition(item, 'custom')" size="small">mdi-delete </v-icon>
                  </template>
                  <span>Remover</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- START FORM DIALOG -->
    <ModalComposition 
      :dialog="dialog_composition" 
      :itemEdit="itemEdit" 
      :product="product" 
      @updateDialog="dialog_composition = false" 
      @addComposition="addComposition" 
    />
  </div>
</template>

<script>
import ModalComposition from "./ModalComposition.vue";
export default {
  created() {
    this.$validator = this.validator;
  },
  components: { ModalComposition },
  props: {
    open: Boolean,
    product: Object,
    validator: Object,
    isViewModal: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    header_custome: [      
      { title: "Presentación", key: "component_product_presentation.name", sortable: false },
      { title: "Cantidad", key: "amount", sortable: false },
      { title: "Accion", sortable: false },
    ],
    dialog_composition: false,
    itemEdit: null,
    itemEditIndex: null,
  }),
  watch: {
    product: {
      handler: function (newValue) {},
      deep: true,
    },
  },
  mounted() {},
  methods: {
    newComposition() {
      this.itemEdit = null;
      this.itemEditIndex = null;
      this.dialog_composition = true;
    },
    editComposition(item) {
      this.itemEditIndex = this.product.composite_kit.indexOf(item);
      this.itemEdit = Object.assign({}, item);
      this.dialog_composition = true;
    },
    addComposition(item) {
      if (this.itemEditIndex == null) {
        this.$emit("addComposition", item);
      } else {
        this.$emit("addComposition", item, this.itemEditIndex);
      }
      this.dialog_composition = false;
    },
    removeComposition(item, colection_name) {
      if (colection_name == "custom") {
        const index_item = this.product.composite_kit.indexOf(item);
        if (index_item > -1) this.$emit("removeComposition", index_item);
      }
    },
  },
};
</script>
